import './index.less';
import { useEffect, useState, useRef } from 'react';
import empty from '@/assets/empty/space.svg';
import ImgAiVoicePlay from '@/assets/edit/voice/play.svg';
import ImgAiVoicePause from '@/assets/edit/voice/pause.svg';
import PlayvoiceImg from '@/assets/aivoices/playvoice.gif';
import { useTranslation } from 'react-i18next';
export default function AiVoiceList({ list }) {
  return (
    <>
      <div>{list.length ? <AiItemCard list={list} /> : <EmptyVoiceList />}</div>
    </>
  );
}
function EmptyVoiceList() {
  const { t } = useTranslation();
  return (
    <div className="empty_box">
      <div className="empty_img">
        <img src={empty} alt="" />
        <div className="empty_text">{t('As_Space_MyVoiceNull1334')}</div>
        <div className="empty_text">{t('As_Space_MyVoiceNull2334')}</div>
      </div>
    </div>
  );
}
// 定义ItemCard组件，用于显示语音列表项
function AiItemCard({ list }) {
  // 当前正在播放的音频索引
  const [playingItem, setPlayingItem] = useState({});
  // 音频元素的引用
  const audioRef = useRef(null);
  useEffect(() => {
    // 清理函数，用于组件卸载时移除事件监听器
    return () => {
      if (audioRef.current) {
        audioRef.current.pause();
        audioRef.current.removeEventListener('ended', handleAudioEnded);
      }
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const handlePlayPause = (item) => {
    if (item.status === 0) return;
    if (playingItem?.id === item.id) {
      item.playFlag = false;
      audioRef.current.pause();
      setPlayingItem(null);
    } else {
      list.filter((item) => {
        item.playFlag = false;
      });
      item.playFlag = true;
      if (audioRef.current) {
        audioRef.current.pause();
        audioRef.current.removeEventListener('ended', handleAudioEnded);
      }
      audioRef.current = new Audio(item.url);
      audioRef.current.addEventListener('ended', handleAudioEnded);
      // audioRef.current.load();
      audioRef.current.play();
      setPlayingItem(item);
    }
  };
  const handleAudioEnded = () => {
    console.log('音频播放结束');
    list.filter((item) => {
      item.playFlag = false;
    });
    setPlayingItem(null);
  };
  // 渲染语音列表
  return (
    <div className="item_card_ai">
      {list.map((item, index) => (
        <div key={index} className={`card_box`}>
          <div className="playimg_box">
            <div className="icon_container">
              <img className="voice_img" src={item.image} alt="" />
              <div className="play_img" onClick={() => handlePlayPause(item)}>
                <img
                  className="play_icon"
                  src={item.playFlag ? ImgAiVoicePlay : ImgAiVoicePause}
                  alt=""
                />
              </div>
            </div>
          </div>
          <div className="card_right">
            <div className="text_box">
              <div className="text">{item.name}</div>
              {item.playFlag && <img src={PlayvoiceImg} alt="" className="playvoice_img" />}
            </div>
            <div className="text_language">
              <span className="language">{item.language}</span>
              {item.gender === 1 && <span>Male</span>}
              {item.gender === 0 && <span>Female</span>}
            </div>
            <div className="badge_box">
              {/* <div className="badge badge-ghost">{item.label}</div> */}
              <div className="badge badge-ghost">{item.purpose || item.label}</div>
            </div>
          </div>
        </div>
      ))}
    </div>
  );
}
